import "core-js/modules/es.array.push.js";
import LoadingDots from '@/dow-platform/components/commerce/shared/loading-dots/index.js';
import AddressBox from '../shared/address-box.vue';
import CheckoutSummary from './checkout-summary.vue';
import CartItem from '../shared/cart-item.vue';
import PurchaseCartAlert from '../shared/purchase-cart-alert.vue';
import StatusBar from '../shared/status-bar.vue';
import ServletHelper from '../../myAccount/helper/servlet-helper';
const checkoutSteps = [{
  title: 'checkout.orderStatus.payment',
  status: false,
  display: 'isCreditCard'
}, {
  title: 'checkout.orderStatus.reviewAndPlaceOrder',
  status: true,
  display: ''
}, {
  title: 'confirmation.Title',
  status: false,
  display: ''
}];
export default {
  name: 'Checkout',
  components: {
    LoadingDots,
    AddressBox,
    CheckoutSummary,
    CartItem,
    PurchaseCartAlert,
    StatusBar
  },
  data() {
    return {
      loading: false,
      checkoutData: null,
      apiCallFailure: false
    };
  },
  async created() {
    this.loading = true;
    try {
      this.checkoutData = await ServletHelper.makeServletCall(this.$store.state.settings.checkout_servlet, '', {
        'Cache-Control': 'no-cache'
      });
    } catch (error) {
      console.error('Error loading checkout data:', error);
      //redirect
      if (error.response?.status === 302) {
        this.$router.push({
          name: 'cart'
        });
      } else {
        //show error alert for other errors
        this.apiCallFailure = true;
      }
    } finally {
      this.loading = false;
    }
  },
  computed: {
    hasForwardingAgent() {
      return this.checkoutData?.entries && this.checkoutData?.entries.some(entry => entry.forwardingAgent);
    },
    isMultiPo() {
      return this.checkoutData?.isMultiPO;
    },
    checkoutEntries() {
      return this.checkoutData?.entries;
    },
    steps() {
      return this.checkoutData?.creditCardSelect ? checkoutSteps : checkoutSteps.filter(step => step.display != 'isCreditCard');
    }
  },
  methods: {
    getI18nMessage: function (key) {
      return window.Granite.I18n.get(key);
    }
  }
};